import request, { ResponseData } from '@/utils/request'

// 获取人员
export async function personList(params) {
  return request('/api/v1/users/tags/users', {
    method: 'post',
    data: params,
  })
}

// 添加人员
export async function addUser(params) {
  return request('/api/v1/users/create', {
    method: 'post',
    data: params,
  })
}

// 删除人员
export async function deleteUser(params) {
  return request('/api/v1/users/delete', {
    method: 'post',
    data: params,
  })
}

// 编辑人员
export async function editUser(params) {
  return request('/api/v1/users/edit', {
    method: 'post',
    data: params,
  })
}

// tag list
export async function tagList(params) {
  return request('/api/v1/users/tags/list', {
    method: 'post',
    data: params,
  })
}

// create tag
export function createTag(params) {
  return request('/api/v1/users/tags/create', {
    method: 'post',
    data: params,
  })
}

// delete tag
export function deleteTag(params) {
  return request('/api/v1/users/tags/delete', {
    method: 'post',
    data: params,
  })
}

// update tag
export function updateTag(params) {
  return request('/api/v1/users/tags/update', {
    method: 'post',
    data: params,
  })
}

// 给用户打标
export function markTag(params) {
  return request('/api/v1/users/add_tag', {
    method: 'post',
    data: params,
  })
}

// 导入员工
export function importPerson(params) {
  return request('/api/v1/sys/staff/upload', {
    method: 'post',
    data: params,
    responseType: 'arrayBuffer',
  })
}

// 导入员工2.0
export function importPersonDownloadCenter(params) {
  return request('/api/v1/sys/staff/upload_url', {
    method: 'post',
    data: params,
  })
}

// 导出员工
export function exportPersonDownloadCenter() {
  return request('/api/v1/sys/staff/export', {
    method: 'post',
  })
}
